import { axiosApiInstance } from './axios';

const apiRoot = '';

const tobaccoWorkOrderApi = {
  get: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/tobacco-work-orders`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  create: async (data) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/tobacco-work-orders`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  getById: async (id) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/tobacco-work-orders/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  update: async (data, id) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/tobacco-work-orders/${id}`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  delete: async (id) => {
    try {
      const res = await axiosApiInstance.delete(`${apiRoot}/tobacco-work-orders/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default tobaccoWorkOrderApi;
